import axios from 'axios';
import {DELETE_TOUR_STATE, GET_TOUR_STATE, GET_TOUR_STATES, POST_TOUR_STATE, UPDATE_TOUR_STATE} from '../routes';

export default {
    async all(options = {}) {
        return await axios.get(GET_TOUR_STATES, options);
    },
    async get(tour_state, options = {}) {
        return await axios.get(GET_TOUR_STATE(tour_state), options);
    },
    async create(data, options = {}) {
        return await axios.post(POST_TOUR_STATE, data, options);
    },
    async update(tour_state, options = {}) {
        return await axios.patch(UPDATE_TOUR_STATE(tour_state), options);
    },
    async delete(tour_state, options = {}) {
        return await axios.delete(DELETE_TOUR_STATE(tour_state), options);
    },
};
